/* @flow */

import CancelablePromise, { handleCallback } from '../cancelable_promise'
type ProgressType = (SyntheticEvent<any>) => void

class ProgressPromise extends CancelablePromise {
  handlers: Array<ProgressType>
  constructor(executor: any) {
    let params = []
    super((resolve, reject, onCancel) => {
      params = [resolve, reject, onCancel]
    })
    this.handlers = []
    executor.apply(
      this,
      params.concat([
        (event) => {
          this.handlers.forEach((handler) => handler(event))
        }
      ])
    )
  }

  onProgress(handler: ProgressType) {
    this.handlers.push(handler)
  }

  then(success?: (any) => any, error?: (any) => any, cancel?: (any) => any) {
    const promise = new this.constructor((resolve, reject, onCancel, onProgress) => {
      onCancel(this._onCancel)
      this.onProgress(onProgress)
      this._promise.then(
        (result) => {
          if (this._status == 'running') this._status = 'resolved'
          promise._status = this._status
          promise._canceled = this._canceled
          if (cancel && this._canceled) {
            handleCallback(resolve, reject, cancel, result)
          } else if (success && !this._canceled) {
            handleCallback(resolve, reject, success, result)
          } else {
            resolve(result)
          }
        },
        (result) => {
          if (this._status == 'running') this._status = 'rejected'
          promise._status = this._status
          promise._canceled = this._canceled
          if (cancel && this._canceled) {
            handleCallback(resolve, reject, cancel, result)
          } else if (error && !this._canceled) {
            handleCallback(resolve, reject, error, result)
          } else {
            reject(result)
          }
        }
      )
    })
    return promise
  }
}

export default ProgressPromise
